if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.quantityInput = undefined;
        this.quantityForm = undefined;
        this.onVariantChangeUnsubscriber = undefined;
        this.variantAvailabilityUnsubscriber = undefined;
        this.cartUpdateUnsubscriber = undefined;
        this.abortController = undefined;
        this.pendingRequestUrl = null;
        this.preProcessHtmlCallbacks = [];
        this.postProcessHtmlCallbacks = [];
        this.imgsrcs = [];
        this.imgsrcsDict = {};
        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.variantAvailabilityUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            if (data?.sectionId !== this.sectionId) return;
            this.applyVariantAvailabilityState(data.variant);
            setTimeout(() => this.applyVariantAvailabilityState(data.variant), 0);
          }
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
        const variant = this.getSelectedVariant(this, true);
        if (this.dataset.layout == "card")
          this.updateCardMedia(variant?.featured_media?.id);
        if (this.dataset.zoomClick == 'lightbox') this.initPhotoSwipe();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initPhotoSwipe() {
        this.imgsrcs = [];
        this.querySelectorAll("li[data-media-id]").forEach((element, index) => {
          element.addEventListener("click", this.openPhotoSwipe.bind(this));
          element.idx = index;
          var imgElement = element.getElementsByTagName("img")[0];
          this.imgsrcs.push({
            src: imgElement.src,
            w: imgElement.getAttribute("data-width"),
            h: imgElement.getAttribute("data-height"),
          });
        });
      }

      openPhotoSwipe(e) {
        var pswpElement = this.querySelectorAll(".pswp")[0];
        var options = {
          index: e.currentTarget.idx,
          history: false,
          focus: false,
          tapAction: "close",
          bgOpacity: 0.6,
        };
        var gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          this.imgsrcs,
          options
        );
        gallery.init();
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.variantAvailabilityUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        // Find the variant-selects/color-swatch that contains the target
        const variantSelector = target.closest('variant-selects, color-swatch');
        if (!variantSelector) {
          return;
        }

        // Match by section ID or product ID instead of DOM containment
        // This handles cases where variant-selects might be in a different DOM location
        const variantSectionId = variantSelector.dataset.section;
        const variantProductId = variantSelector.dataset.product;
        const thisSectionId = this.dataset.section || this.dataset.originalSection;
        const thisProductId = this.dataset.productId;

        // Check if this product-info matches the variant selector's section/product
        const matchesSection = variantSectionId && thisSectionId && variantSectionId === thisSectionId;
        const matchesProduct = variantProductId && thisProductId && variantProductId === thisProductId;
        const isTargetContained = this.contains(event.target) || this.contains(target) || (variantSelector && this.contains(variantSelector));

        // Process if section/product matches OR if DOM containment works
        if (!matchesSection && !matchesProduct && !isTargetContained) {
          return;
        }
        event.productInfoHandled = true;

        try {
          this.resetProductFormState();
          const productUrl =
            target.dataset.productUrl ||
            this.pendingRequestUrl ||
            this.dataset.url;
          this.pendingRequestUrl = productUrl;
          const shouldSwapProduct = this.dataset.url !== productUrl;
          const shouldFetchFullPage =
            this.dataset.updateUrl === "true" &&
            shouldSwapProduct &&
            this.dataset.layout != "card";

          const requestUrl = this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          );
          this.renderProductInfo({
            requestUrl,
            targetId: target.id,
            callback:
              shouldSwapProduct && this.dataset.layout != "card"
                ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
                : this.handleUpdateProductInfo(productUrl, shouldFetchFullPage),
          });
        } catch (error) {
          console.error('Error in handleOptionValueChange:', error);
          return;
        }
      }

      resetProductFormState() {
        try {
          const productForm = this.productForm;
          if (productForm) {
            productForm.toggleSubmitButton?.(true);
            productForm.handleErrorMessage?.();
          }
        } catch (error) {
          // Silently fail - don't block variant changes if form state reset fails
          console.warn('Failed to reset product form state:', error);
        }
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            if (this.dataset.layout == "card") {
              var wc_forloop_index = parseInt(
                document
                  .querySelector(`#${targetId}`)
                  .getAttribute("data-forloop-index")
              );
              const originalHtml = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const html = originalHtml.getElementById(this.id)
                ? originalHtml.getElementById(this.id)
                : originalHtml;
              if (wc_forloop_index >= 0) {
                html
                  .querySelectorAll(".wc_selector_operation")
                  .forEach(function (self, index) {
                    self.setAttribute("data-forloop-index", wc_forloop_index);
                    var wc_name_attr = self.getAttribute("name");
                    self.setAttribute("name", wc_name_attr + wc_forloop_index);
                  });
              }
              callback(html);
            } else {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              if (html.tagNam == "PRODUCT-INFO")
                html.setAttribute("data-update-url", "false");
              else if (
                html.querySelector("product-info") &&
                this.dataset.isQuickView
              ) {
                html
                  .querySelector("product-info")
                  .setAttribute("data-update-url", "false");
                html
                  .querySelector("product-info")
                  .setAttribute("data-is-quick-view", "true");
              }
              callback(html);
            }
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
            this.clearPendingOption(targetId);
          })
          .catch((error) => {
            this.clearPendingOption(targetId);
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      clearPendingOption(targetId) {
        if (!targetId) return;
        const input = document.getElementById(targetId);
        input?.closest("variant-selects, color-swatch")?.querySelector(`label[for="${CSS.escape(targetId)}"]`)?.classList.remove("is-loading");
      }

      getSelectedVariant(productInfoNode, allowCurrentVariantFallback = false) {
        const selectedVariant =
          productInfoNode.querySelector(
            "variant-selects [data-selected-variant]"
          )?.innerHTML ||
          productInfoNode.querySelector("color-swatch [data-selected-variant]")
            ?.innerHTML;
        if (selectedVariant) {
          try {
            return JSON.parse(selectedVariant);
          } catch (error) {
            return null;
          }
        }
        return allowCurrentVariantFallback ? this.getFallbackVariant(productInfoNode) : null;
      }

      getVariantData(productInfoNode = this) {
        const variantDataScript =
          productInfoNode.querySelector("variant-selects [data-variants]") ||
          productInfoNode.querySelector("color-swatch [data-variants]");
        if (variantDataScript) {
          try {
            return JSON.parse(variantDataScript.textContent);
          } catch (error) {
            return null;
          }
        }

        const productJsonScript = productInfoNode.querySelector('script[type="application/json"][id^="WH-ProductJson"]');
        if (!productJsonScript) return null;
        try {
          const data = JSON.parse(productJsonScript.textContent);
          return Array.isArray(data?.variants) ? data.variants : null;
        } catch (error) {
          return null;
        }
      }

      getCurrentVariantId(productInfoNode = this) {
        return productInfoNode.querySelector('input.product-variant-id[name="id"], input[name="id"]')?.value || null;
      }

      getFallbackVariant(productInfoNode = this) {
        const variants = this.getVariantData(productInfoNode);
        if (!Array.isArray(variants) || !variants.length) return null;

        const currentVariantId = this.getCurrentVariantId(productInfoNode);
        if (!currentVariantId) return null;
        return variants.find((variant) => String(variant.id) === String(currentVariantId)) || null;
      }

      getSelectedOptionValues() {
        if (!this.variantSelectors) {
          return [];
        }
        const optionElements = Array.from(
          this.variantSelectors.querySelectorAll("fieldset, select")
        );
        const selectedOptions = [];

        optionElements.forEach((element) => {
          if (element.tagName === "FIELDSET") {
            const checkedInput = element.querySelector(
              'input[type="radio"]:checked'
            );
            if (checkedInput) {
              selectedOptions.push(checkedInput.value);
            }
          } else if (element.tagName === "SELECT") {
            const selectedOption = element.selectedOptions?.[0];
            if (selectedOption) {
              selectedOptions.push(selectedOption.value);
            }
          }
        });

        return selectedOptions;
      }

      getVariantIdFromSelectedOptions() {
        const variants = this.getVariantData();
        const selectedOptions = this.getSelectedOptionValues();
        if (!variants || !selectedOptions.length) return this.getFallbackVariant()?.id || null;

        const matchedVariant = variants.find((variant) => {
          if (!Array.isArray(variant.options)) return false;
          if (variant.options.length !== selectedOptions.length) return false;
          return variant.options.every(
            (value, index) => value === selectedOptions[index]
          );
        });

        return matchedVariant?.id || null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];
        !shouldFetchFullPage &&
          params.push(`section_id=${this.dataset.originalSection}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        } else {
          const fallbackVariantId = this.getVariantIdFromSelectedOptions();
          if (fallbackVariantId) {
            params.push(`variant=${fallbackVariantId}`);
          }
        }
        const result = `${url}${url.indexOf("?") >= 0 ? "&" : "?"}${params.join("&")}`;
        return result;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        const currentVariantSelects = this.variantSelectors;
        if (!variantSelects || !currentVariantSelects) return;

        const currentOptionCount = currentVariantSelects.querySelectorAll("fieldset, select").length;
        const nextOptionCount = variantSelects.querySelectorAll("fieldset, select").length;

        if (currentOptionCount <= 1 && nextOptionCount <= 1) {
          const currentSelectedVariant = currentVariantSelects.querySelector("[data-selected-variant]");
          const nextSelectedVariant = variantSelects.querySelector("[data-selected-variant]");
          if (currentSelectedVariant && nextSelectedVariant) {
            currentSelectedVariant.innerHTML = nextSelectedVariant.innerHTML;
          }
          return;
        }

        HTMLUpdateUtility.viewTransition(
          currentVariantSelects,
          variantSelects,
          this.preProcessHtmlCallbacks
        );
      }
      updateCardVendor(vendorName) {
        const card = this.closest(".card") || this.querySelector(".card");
        if (!card) return;

        const vendorElement = card.querySelector(".card_vendor");
        if (vendorElement) {
          vendorElement.textContent = vendorName;
        }
      }
      updateCardProductType(productType) {
        const productTypeElement = this.querySelector(".card_type");
        if (productTypeElement) {
          productTypeElement.textContent = productType;
        }
      }
      updateCardTitleMarkup(sourceTitleElement) {
        const productTitleElement = this.querySelector(".full-unstyled-link");
        if (productTitleElement && sourceTitleElement) {
          productTitleElement.innerHTML = sourceTitleElement.innerHTML;
        }
      }
      handleUpdateProductInfo(productUrl, updateFullPage) {
        return (html) => {
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          const vendorName = html.querySelector(".card_vendor")?.textContent;

          if (vendorName) {
            this.updateCardVendor(vendorName);
          } else {
            this.updateCardVendor("");
          }

          const productType = html.querySelector(".card_type")?.textContent;
          if (productType) {
            this.updateCardProductType(productType);
          } else {
            this.updateCardProductType("");
          }

          const productTitle = html.querySelector(".full-unstyled-link");
          if (productTitle) {
            this.updateCardTitleMarkup(productTitle);
          }

          if (this.dataset.layout == "card") {
            if (this.dataset.url != productUrl) {
              const productMediaItem = html.querySelectorAll(
                ".product__media-item"
              );
              productMediaItem.forEach((mediaItem) => {
                mediaItem.dataset.mediaId = this.replaceStringBeforeLastDash(
                  mediaItem.dataset.mediaId,
                  `${this.dataset.section}-${this.dataset.productId}`
                );
              });
              this.querySelector(".card__media").innerHTML =
                html.querySelector(".card__media").innerHTML;
            }
            this.dataset.url = productUrl;
          }

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant);

          if (!variant) {
            this.setUnavailable();
            return;
          }
          if (variant.id && this.dataset.isQuickView) {
            this.querySelector(
              'input.product-variant-id[name="id"]'
            ).setAttribute("value", variant.id);
          }

          this.updateMedia(html, variant?.featured_media?.id);
          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.querySelector(`#${id}-${this.sectionId}`);
            var main_url_1 = `#${id}-${this.dataset.section}`;
            var main_url_2 = `#${id}-quickadd-${this.dataset.section}`;
            const destination = this.querySelector(main_url_1)
              ? this.querySelector(main_url_1)
              : this.querySelector(main_url_2);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination(
            "badge",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateQuantityRules(this.sectionId, html);

          if (this.querySelector(`#Quantity-Rules-${this.dataset.section}`)) {
            this.querySelector(
              `#Quantity-Rules-${this.dataset.section}`
            )?.classList.remove("hidden");
          } else {
            this.querySelector(
              `#Quantity-Rules-quickadd-${this.dataset.section}`
            )?.classList.remove("hidden");
          }
          if (this.querySelector(`#Volume-Note-${this.dataset.section}`)) {
            this.querySelector(
              `#Volume-Note-${this.dataset.section}`
            )?.classList.remove("hidden");
          } else {
            this.querySelector(
              `#Volume-Note-quickadd-${this.dataset.section}`
            )?.classList.remove("hidden");
          }
          var fullSelected = 1;
          if (html.querySelector(`#ProductSubmitButton-${this.sectionId}`)) {
            html
              .querySelectorAll(
                ".product-form__input.product-form__input--pill, .product-form__input.product-form__input--swatch, .product_form_input.product-form__input, .product-form__input.product-form__input--dropdown"
              )
              .forEach(function (self, index) {
                let radioCheckedValue = self.querySelector(
                  'input[type="radio"]:checked'
                );

                if (radioCheckedValue) {
                  let value = radioCheckedValue.getAttribute("value");
                  if (value !== variant.options[index]) {
                    fullSelected = 0;
                  }
                }

                if (self.querySelector("select")) {
                  const selectedOption =
                    self.querySelector("select").selectedOptions[0];
                  var selectedValue = selectedOption.getAttribute("value");
                  if (selectedValue !== variant.options[index]) {
                    fullSelected = 0;
                  }
                }
              });
            if (fullSelected == 0) {
              this.toggleProductFormButtons(
                true,
                window.variantStrings.unavailable
              );
            } else {
              const buttonDisabled = !variant.available;
              this.toggleProductFormButtons(
                buttonDisabled,
                buttonDisabled ? window.variantStrings.soldOut : window.variantStrings.addToCart
              );
            }
          } else {
            html
              .querySelectorAll(
                ".product-form__input.product-form__input--pill, .product_form_input.product-form__input"
              )
              .forEach(function (self, index) {
                if (self.querySelector('input[type="radio"]:checked')) {
                  if (
                    self
                      .querySelector('input[type="radio"]:checked')
                      .getAttribute("value") !== variant.options[index]
                  ) {
                    fullSelected = 0;
                  }
                }
                if (self.querySelector("select")) {
                  const selectedOption =
                    self.querySelector("select").selectedOptions[0];
                  var selectedValue = selectedOption.getAttribute("value");
                  if (selectedValue !== variant.options[index]) {
                    fullSelected = 0;
                  }
                }
              });
            if (fullSelected == 0) {
              this.toggleProductFormButtons(
                true,
                window.variantStrings.unavailable
              );
            } else {
              const buttonDisabled = !variant.available;
              this.toggleProductFormButtons(
                buttonDisabled,
                buttonDisabled ? window.variantStrings.soldOut : window.variantStrings.addToCart
              );
            }
          }
          this.applyVariantAvailabilityState(variant);
          setTimeout(() => this.applyVariantAvailabilityState(variant), 0);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantOrId) {
        const variant = variantOrId && typeof variantOrId === "object" ? variantOrId : null;
        const variantId = variant?.id ?? variantOrId;
        const selecter =
          this.dataset.layout == "card"
            ? this.dataset.section + "-" + this.dataset.productId
            : this.dataset.section;
        //webcontrive code start - Thumbnail click handler (fallback only)
        // Note: media-gallery.js handles thumbnail clicks primarily
        // This is only a fallback if media-gallery is not available
        var $wc_this = this;
        setTimeout(function () {
          const mediaGallery = document.querySelector('media-gallery');
          // Only add fallback if media-gallery doesn't exist
          if (!mediaGallery) {
            const thumbnailButtons = document.querySelectorAll('.thumbnail-list__item .thumbnail');
            thumbnailButtons.forEach((button) => {
              if (button._fallbackHandler) return; // Already has handler

              const mediaId = button.getAttribute('data-media-id') ||
                button.closest('.thumbnail-list__item')?.getAttribute('data-target');

              if (!mediaId) return;

              button._fallbackHandler = function (e) {
                e.preventDefault();
                e.stopPropagation();

                const allImages = document.querySelectorAll(".product_main_image");
                allImages.forEach((image) => {
                  if (image.getAttribute("data-media-id") === mediaId) {
                    image.classList.add("is-active");
                    image.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
                  } else {
                    image.classList.remove("is-active");
                  }
                });
              };

              button.addEventListener("click", button._fallbackHandler, true);
            });
          }
        }, 300);
        const forms = this.querySelectorAll(
          `#product-form-${selecter}, #product-form-sticky-${selecter}, #product-form-installment-${selecter}`
        );
        forms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          const isAvailable = Boolean(variant?.available);
          if (input) {
            const nextVariantId = variantId ?? "";
            if (input.value !== String(nextVariantId)) {
              input.value = nextVariantId;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
            input.disabled = !isAvailable;
          }
          productForm.closest("product-form")?.toggleSubmitButton?.(
            !isAvailable,
            variant ? (isAvailable ? window.variantStrings.addToCart : window.variantStrings.soldOut) : window.variantStrings.unavailable
          );
          this.updateProductFormOptimisticData(productForm, variant);
        });
      }

      applyVariantAvailabilityState(variant) {
        const selecter =
          this.dataset.layout == "card"
            ? this.dataset.section + "-" + this.dataset.productId
            : this.dataset.section;
        const isAvailable = Boolean(variant?.available);
        const nextText = variant
          ? (isAvailable ? window.variantStrings.addToCart : window.variantStrings.soldOut)
          : window.variantStrings.unavailable;
        const forms = this.querySelectorAll(
          `#product-form-${selecter}, #product-form-sticky-${selecter}`
        );
        const buttons = new Set();

        forms.forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          if (input) input.disabled = !isAvailable;
          const button = form.querySelector('[type="submit"]') || form.closest("product-form")?.querySelector('[type="submit"]');
          if (button) buttons.add(button);
        });

        this.querySelectorAll(
          `#ProductSubmitButton-${selecter}, #ProductSubmitButton-Sticky-${selecter}`
        ).forEach((button) => buttons.add(button));

        buttons.forEach((button) => {
          if (isAvailable) {
            button.removeAttribute("disabled");
          } else {
            button.setAttribute("disabled", "disabled");
          }
          this.setSubmitButtonText(button, nextText);
        });
      }

      setSubmitButtonText(button, text) {
        if (!button || !text || button.hasAttribute("data-preserve-submit-text")) return;
        const label = button.querySelector(".add-to-cart-ticker")
          || Array.from(button.querySelectorAll("span")).find((span) =>
            !span.classList.contains("visually-hidden")
            && !span.classList.contains("loading__spinner")
            && !span.querySelector(".loading__spinner")
          );
        if (label) label.textContent = text;
      }

      getVariantImageUrl(variant) {
        return variant?.featured_image?.src || variant?.featured_media?.preview_image?.src || "";
      }

      getVariantOptionMeta(variant) {
        const options = Array.isArray(variant?.options) ? variant.options : [];
        if (!options.length) return { name: "", value: variant?.title !== "Default Title" ? variant?.title || "" : "" };

        const optionGroups = Array.from(this.variantSelectors?.querySelectorAll("fieldset, select") || []);
        const colorIndex = optionGroups.findIndex((group) => {
          const label = group.querySelector("legend")?.textContent || group.getAttribute("name") || group.dataset.optionName || "";
          return label.toLowerCase().includes("color");
        });
        const optionIndex = colorIndex >= 0 ? colorIndex : (options.length === 1 ? 0 : -1);
        if (optionIndex < 0) return { name: "", value: variant?.title !== "Default Title" ? variant?.title || "" : "" };

        const optionGroup = optionGroups[optionIndex];
        const name = optionGroup?.querySelector("legend")?.textContent?.replace(/\s+/g, " ").trim()
          || optionGroup?.getAttribute("name")
          || "";
        return { name, value: options[optionIndex] || "" };
      }

      updateProductFormOptimisticData(productForm, variant) {
        if (!productForm || !variant) return;

        const imageUrl = this.getVariantImageUrl(variant);
        if (imageUrl) {
          productForm.dataset.productImage = imageUrl;
          productForm.dataset.productImageAlt = variant.featured_image?.alt || variant.featured_media?.alt || productForm.dataset.productTitle || "";
        } else {
          productForm.removeAttribute("data-product-image");
          productForm.removeAttribute("data-product-image-alt");
        }

        if (variant.price != null) productForm.dataset.productPrice = String(variant.price);
        if (variant.id) {
          const baseUrl = this.dataset.url || window.location.pathname;
          productForm.dataset.productUrl = `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}variant=${variant.id}`;
        }

        const optionMeta = this.getVariantOptionMeta(variant);
        if (optionMeta.value) {
          productForm.dataset.productVariantTitle = optionMeta.value;
          if (optionMeta.name) productForm.dataset.productVariantOptionName = optionMeta.name;
        } else {
          productForm.removeAttribute("data-product-variant-title");
          productForm.removeAttribute("data-product-variant-option-name");
        }
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        this.toggleProductFormButtons(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        this.querySelectorAll(selectors).forEach(({ classList }) =>
          classList.add("hidden")
        );
      }

      updateCardMedia(variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        const card = this.closest(".card") || this.querySelector(".card");
        if (!card) return;
        const newMedia = card.querySelector(
          `[data-media-id="${this.dataset.section}-${this.dataset.productId}-${variantFeaturedMediaId}"]`
        );
        if (!newMedia) return;
        const modalContent = card.querySelector(".card__media");
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        parent.prepend(newMedia);
      }

      replaceStringBeforeLastDash(str, replacement) {
        // Find the position of the last dash
        const lastDashIndex = str.lastIndexOf("-");

        // If there's no dash, return the string unchanged
        if (lastDashIndex === -1) {
          return str;
        }

        // Extract everything after the last dash and prepend the replacement
        return replacement + str.substring(lastDashIndex);
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) {
          return;
        }
        if (this.dataset.layout == "card") {
          this.updateCardMedia(variantFeaturedMediaId);
        } else {
          const syncMediaList = (selector) => {
            const sourceList = this.querySelector(selector);
            const destinationList = html.querySelector(selector);
            if (!sourceList || !destinationList) return;

            sourceList.replaceChildren(...Array.from(destinationList.children));

            const sourceSlider = sourceList.closest("slider-component");
            const destinationSlider = destinationList.closest("slider-component");
            const sourceTotal = sourceSlider?.querySelector(".slider-counter--total");
            const destinationTotal = destinationSlider?.querySelector(".slider-counter--total");
            if (sourceTotal && destinationTotal) sourceTotal.textContent = destinationTotal.textContent;
            sourceSlider?.resetPages?.();
          };

          if (this.hasAttribute("data-zoom-on-hover") && typeof enableZoomOnHover == 'function') enableZoomOnHover(2);
          if (!this.dataset.isQuickView) {
            syncMediaList("#Slider-Gallery-" + this.sectionId);
            syncMediaList("#Slider-Thumbnails-" + this.sectionId);
          }

          // set featured media as active in the media gallery
          // Media ID format matches template: {{ section.id }}-{{ media.id }}
          const sectionId = this.dataset.section || this.dataset.originalSection;
          const mediaIdToSet = `${sectionId}-${variantFeaturedMediaId}`;
          const mediaGallery = this.querySelector(`media-gallery`);

          // setActiveMedia only takes one parameter (mediaId), not two
          if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
            mediaGallery.setActiveMedia(mediaIdToSet);
          }

          // update media modal
          const modalContent = this.productModal?.querySelector(
            `.product-media-modal__content`
          );
          const newModalContent = html.querySelector(
            `product-modal .product-media-modal__content`
          );

          if (modalContent && newModalContent)
            modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.querySelector(
          `#Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productForms() {
        return this.querySelectorAll(`product-form`);
      }

      toggleProductFormButtons(disable = true, text) {
        this.productForms.forEach((productForm) => {
          productForm.toggleSubmitButton?.(disable, text);
        });
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return (
          this.querySelector("variant-selects") ||
          this.querySelector("color-swatch")
        );
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

document.addEventListener("change", function (event) {
  if (event.target.classList.contains("wc_selector_operation")) {
    let closestFeature = event.target.closest(".featured_collection_home");
    if (!closestFeature) return;

    let dataId = closestFeature.getAttribute("data-id");

    setTimeout(() => {
      let radioButtons = closestFeature.querySelectorAll(
        ".wc_selector_operation"
      );
      radioButtons.forEach((radio) => {
        let originalName =
          radio.getAttribute("data-original-name") ||
          radio.getAttribute("name");
        radio.setAttribute("data-original-name", originalName);
        radio.setAttribute("name", `${originalName}_${dataId}`);
      });
    }, 1000);
  }
});
